// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","371":"component---src-pages-tos-js","745":"component---src-pages-privacy-js"}[chunkId] + "-" + {"125":"cc134d1447836ddd972f","293":"c17a702fa7b6c67b08d7","371":"97c611f1788a8e638904","745":"1dba31bf397f0152ead3"}[chunkId] + ".js";
};